import DropdownFilter from "../SD_einsehen/DropdownFilter";

export const streckenverlaufHeader = [
    {
        accessor: 'id_strecke',
        Header: 'StreckenID'
    },
    {
        accessor: 'beginn',
        Header: 'von',
        width: '12em',
        Filter: DropdownFilter
    },
    {
        accessor: 'ende',
        Header: 'nach',
        width: '12em',
        Filter: DropdownFilter
    },
    {
        accessor: 'anzahl',
        Header: 'Länge',
        width: '5em'
    }
];